import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getActionLogs } from '../api/actionApi'

/**
 * Aksiyon İşlem Geçmişi sunucu-durumu (074). Yalnız {@code enabled} (dialog açık) iken sorgulanır — buton her
 * detay render'ında gereksiz istek atmasın. id geçersizse pasif.
 *
 * <p>Aktif dil ({@code i18n.language}) key'e girer: işlem adı ({@code operationName}, REF_OPERATION_CODE)
 * sunucuda {@code Accept-Language}'e göre çözülür → dil TR↔EN değiştiğinde eski dilde kalmasın.
 */
export function useActionLogs(id: number | null, enabled: boolean) {
  const { i18n } = useTranslation()
  return useQuery({
    queryKey: ['action-logs', id, i18n.language],
    queryFn: () => getActionLogs(id as number),
    enabled: enabled && id != null && !Number.isNaN(id),
  })
}
